const state = {
  internetCommerceIngList: {
    isLoading: false,
    content: [],
    pagination: {},
  },
  internetCommerceEndList: {
    isLoading: false,
    content: [],
    pagination: {},
  },
  internetCommerceDetail: {},
  internetCommerceQuotationIngList: {
    isLoading: false,
    content: [],
    pagination: {},
  },
  internetCommerceQuotationEndList: {
    isLoading: false,
    content: [],
    pagination: {},
  },
  internetCommerceQuotationDetail: {},
  internetCommercUserQuotationList: {
    isLoading: false,
    content: [],
    pagination: {},
  },
  internetCommercUserQuotationNewList: {
    isLoading: false,
    content: [],
    pagination: {},
  },
  internetCommerce: {},
  internetCommerceQuotationCntCheck: 0,
  internetCommerceApplyDetail: {},
  internetCommerceApplyList: {
    content: [],
    pagination: {},
  },
  internetCommerceApplyNewCount: 0,
  internetCommerceForecast: {},
  internetChatQuotationList: {
    content: [],
    pagination: {},
  },
};

export default state;
